import { Box, Center, VStack, Heading, } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { MdCreditCard } from 'react-icons/md';
import FaceliftButton from '@/components/Atoms/FaceliftButton/FaceliftButton';
import FaceliftText from '@/components/Atoms/FaceliftText/FaceliftText';

const Error402 = () => {
  const navigate = useNavigate();

  const handleGoToBilling = () => {
    // Navigate to billing page or external subscription management
    // For now, redirecting to dashboard - update as needed
    navigate('/');
  };

  return (
    <Center minH="100vh" bg="brand.pageBackground" px={{ base: 4, md: 8 }}>
      <VStack gap={4} maxW="500px" textAlign="center">
        {/* Error Code */}
        <Heading
          fontSize={{ base: '5xl', md: '6xl' }}
          fontWeight="bold"
          color="brand.warning"
          lineHeight="1"
        >
          402
        </Heading>

        {/* Main Message with Icon */}
        <Box display="flex" alignItems="center" gap={3}>
          <Box
            width={{ base: '40px', md: '50px' }}
            height={{ base: '40px', md: '50px' }}
            borderRadius="full"
            bg="brand.warning"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
          >
            <MdCreditCard size={24} color="white" />
          </Box>
          <Heading
            fontSize={{ base: 'lg', md: 'xl' }}
            fontWeight="600"
            color="brand.textDark"
          >
            Payment Required
          </Heading>
        </Box>

        {/* Subtitle */}
        <FaceliftText
          fontSize={{ base: 'sm', md: 'md' }}
          color="brand.textDark"
          opacity={0.7}
          maxW="400px"
        >
          Your subscription has expired or payment is pending. Please renew your
          subscription to continue using our services.
        </FaceliftText>

        {/* Action Button */}
        <FaceliftButton
          onClick={handleGoToBilling}
          size="sm"
          mt={2}
          _hover={{ opacity: 0.9 }}
        >
          Renew Subscription
        </FaceliftButton>
      </VStack>
    </Center>
  );
};

export default Error402;

